import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import ClassDashboard from 'components/ClassDashboard';
import moment from 'moment';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch } from "util/router.js";
import ClassesTable from 'components/ClassesTable';
import NewClassButton from 'components/Store/NewClassButton'
import {useHistory, useRouteMatch} from 'util/router'

const useStyles = makeStyles(styles);

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});


function LiveClassesSection(props) {

  const match = useRouteMatch()

  moment.locale('en', {
    calendar : {
        lastDay : '[Yesterday]',
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        lastWeek : '[last] dddd [at] LT',
        nextWeek : 'dddd [at] LT',
        sameElse : 'dddd MMM Do'
    }
});

  const [showPrevious, setShowPrevious] = React.useState(false)

  function ClassListSection() {
    return (
    <div className="container px-0">
      <section>
        <div className='d-flex d-row justify-content-between align-items-center mb-4'>
          <div className="d-flex d-row align-items-center">
            <h2 className="font-weight-bold">Schedule</h2>
            <button 
            type="button" 
            className="btn btn-link"
            onClick={() => setShowPrevious(!showPrevious)}
            >
              {showPrevious ? "Show Upcoming" : "Show Previous"}
            </button>
          </div>
          <NewClassButton className="float-right" {...props}/>
        </div>
        <ClassesTable
          {...props}
          showPrevious={showPrevious}
        />
      </section>
    </div>
    );
  }

  return (
    <Switch>
      <Route 
            path={`${match.url}/class/:platformID`} 
            render={props => {
              return <ClassDashboard {...props}/>
            }} 
        />
        <Route path="/">
          <ClassListSection />
        </Route>
    </Switch>
  );
}

export default LiveClassesSection;


/* USE
    //The var "humanizedGreeting" below will equal (assuming the time is 8pm) "Good evening, James."
    
    var user = "James";
    var humanizedGreeting = "Good " + getGreetingTime(moment()) + ", " + user + ".";
*/
function getGreetingTime (m) {
	var g = null; //return g
	
	if(!m || !m.isValid()) { return; } //if we can't find a valid or filled moment, we return.
	
	var split_afternoon = 12 //24hr time to split the afternoon
	var split_evening = 17 //24hr time to split the evening
	var currentHour = parseFloat(m.format("HH"));
	
	if(currentHour >= split_afternoon && currentHour <= split_evening) {
		g = "afternoon";
	} else if(currentHour >= split_evening) {
		g = "evening";
	} else {
		g = "morning";
	}
	
	return g;
}